import {Component, Inject} from '@angular/core';
import {ToasterConfig} from 'angular2-toaster';
import {APP_CONFIG_TOKEN, AppConfig} from '../../app.config';

@Component({
    selector: 'app-focus',
    templateUrl: './focus.component.html',
    styleUrls: ['./focus.component.scss']
})
export class FocusComponent {
    toasterConfig: ToasterConfig;

    constructor(@Inject(APP_CONFIG_TOKEN) private readonly cfg: AppConfig) {
        this.toasterConfig = new ToasterConfig({
            animation: 'fade',
            positionClass: 'toast-top-center',
            limit: 1,
            tapToDismiss: true,
            showCloseButton: false,
            newestOnTop: true,
            timeout: cfg.toasterTimeout,
            mouseoverTimerStop: false
        });
    }
}
